import React from 'react';
import { each } from 'lodash';
import PropTypes from 'prop-types';
import { req, useApiGet } from 'react-reqq-lite';

export const FormContext = React.createContext();

export const ErrorLabel = ({ name }) => {
  const { error } = React.useContext(FormContext);
  if (!error[name]) return null;
  return (
    <p className="mt-2 text-sm text-red-600" id={name}>
      {error[name]}
    </p>
  );
};

ErrorLabel.propTypes = {
  name: PropTypes.string.isRequired,
};

export const useValidation = (schema, errorId) => {
  const apiError = useApiGet(`ALERT_ERROR/${errorId}`, '');
  const [error, setError] = React.useState({});
  const submit = React.useCallback(
    async (payload, onSubmit) => {
      try {
        await schema.validate(payload, { abortEarly: false });
        setError({});
        onSubmit(payload);
      } catch (err) {
        const newError = {};
        each(err?.inner, (v) => {
          newError[v.path] = v.message;
        });
        setError(newError);
      }
    },
    [schema, setError]
  );
  React.useEffect(() => {
    return () => {
      req.set(`ALERT_ERROR/${errorId}`, null);
    };
  }, [errorId]);
  const errObj = React.useMemo(() => {
    const err = { ...error };
    if (apiError) err.message = apiError;
    return err;
  }, [error, apiError]);
  return [errObj, submit];
};

function Form({ onSubmit, children, error, ...props }) {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit();
  };
  return (
    <FormContext.Provider value={{ error }}>
      <form onSubmit={handleSubmit} {...props}>
        {children}
      </form>
    </FormContext.Provider>
  );
}

Form.defaultProps = {
  error: {},
};

Form.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.instanceOf(Object),
    PropTypes.string,
    PropTypes.number,
  ]).isRequired,
  error: PropTypes.instanceOf(Object),
};

export default Form;
